import { React, useState, useEffect } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { Squircle } from "@squircle-js/react";
import { useParams, } from "react-router-dom";
import joi from 'joi';
import { Helmet } from 'react-helmet'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faEnvelope, faPersonChalkboard, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar } from '../../../main.js'

import '../../../main.css'
import './ManageEventEdit.css'
import './MManageEventEdit.css'

import logo_mainbyton from '../../../assets/pictures/logos/4Helferzeit-Logo2x.webp'
import m_logo_mainbyton from '../../../assets/pictures/logos/1Helferzeit-Logo2x.webp'
import img_not_found from '../../../assets/pictures/imgnotfound.webp'

import Cookies from 'universal-cookie'


const valschema_event = {
    //orgid entfernen
    "name": joi.string().trim().min(3).max(30).pattern(/^[A-Za-z0-9.\-/\sÀ-ÿ]*$/).required(),
    "shortname": joi.string().trim().min(3).max(10).pattern(/^[a-z0-9\-]*$/).required(),
    "longname": joi.string().trim().min(3).max(70).pattern(/^[A-Za-z0-9.\-/\sÀ-ÿ*]*$/).required(),
    "slogan": joi.string().trim().min(3).max(30).pattern(/^[A-Za-z0-9.\-/\sÀ-ÿ!?*]*$/).required(),
    "logo_img": joi.string().trim().min(5).max(400).uri({ allowRelative: true, }).required(),
    "hero_img": joi.string().trim().min(5).max(400).uri({ allowRelative: true, }).required(),
    "url": joi.string().trim().min(5).max(400).uri().required(),
    //verschachtelung entfernt
    "box1Header": joi.string().trim().min(3).max(50).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()]*$/).required(),
    "box1Text": joi.string().trim().min(10).max(2000).pattern(/^(<br>|[A-Za-z0-9.,#\-/\sÀ-ÿ!?*'()])*$/).required(),
    "box1HeroImg": joi.required().allow("", joi.string().trim().min(5).max(400).uri({ allowRelative: true, })),
    "box2Header": joi.string().trim().min(3).max(50).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()]*$/).required(),
    "box2Text1": joi.string().trim().min(10).max(2000).pattern(/^(<br>|[A-Za-z0-9.,#\-/\sÀ-ÿ!?*'()])*$/).required(),
    "box2Text2": joi.string().trim().min(10).max(2000).pattern(/^(<br>|[A-Za-z0-9.,#\-/\sÀ-ÿ!?*'()])*$/).required(),
    "box2CtaText": joi.string().trim().min(3).max(20).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*]*$/).required(),
    "box3Header": joi.string().trim().min(3).max(50).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()]*$/).required(),
    "box3Contents": joi.string().trim().min(3).max(200).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()]*$/).required(),
    "box3LookingFor": joi.string().trim().min(3).max(200).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()]*$/).required(),
    "box3Text": joi.string().trim().min(10).max(2000).pattern(/^(<br>|[A-Za-z0-9.,#\-/\sÀ-ÿ!?*()])*$/).required(),
    "box3CtaText": joi.string().trim().min(3).max(20).pattern(/^[A-Za-z0-9.,#\-/\sÀ-ÿ!?*]*$/).required(),

    "customstyle": joi.number().valid(0, 1).required(),
    //verschachtelung entfernt

    "colorPrimary": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorPrimaryGradient": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorSecondary": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorTileBg": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorStdText": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorBtnText": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    "colorStdTextOnTile": joi.string().trim().min(7).max(9).pattern(/^[A-Za-z0-9#]*$/).required(),
    //verschachtelung entfernt
    "dateStart": joi.string().isoDate().required(),
    "dateEnd": joi.string().isoDate().required(),
    "applicationStart": joi.string().isoDate().required(),
    "applicationEnd": joi.string().isoDate().required(),
    "datesLocked": joi.number().valid(0, 1).required(),
    "applicationEnabled": joi.number().valid(0, 1).required(),
    "waitlistEnabled": joi.number().valid(0, 1).required(),
    "groupRegistrationEnabled": joi.number().valid(0, 1).required(),
    "maxGroupPersons": joi.number().integer().min(1).max(30).required(),
    "remarksEnabled": joi.number().valid(0, 1).required(),
    "active": joi.number().valid(0, 1, 2).required(),
    "public": joi.number().valid(0, 1).required()
}

export default function ManageEventEdit() {

    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [eventData, setEventData] = useState([])
    var [loadedEventData, setLoadedEventData] = useState(0)

    //TODO check permission or is manager

    const param_orgid = new URLSearchParams(window.location.search).get("orgid")

    var { eventid = 0 } = useParams() ?? {};


    var [formData, setFormData] = useState({
        name: "",
        shortname: "",
        longname: "",
        slogan: "Jetzt mithelfen!",
        logo_img: "/1Helferzeit-Logo2x.png",
        hero_img: "/eventpics/default/svteam_rounded.webp",
        url: "",
        box1Header: "",
        box1Text: "",
        box1HeroImg: "",
        box2Header: "",
        box2Text1: "",
        box2Text2: "",
        box2CtaText: "",
        box3Header: "",
        box3Text: "",
        box3Contents: "",
        box3LookingFor: "",
        box3CtaText: "Mitmachen",
        dateStart: "",
        dateEnd: "",
        applicationStart: "",
        applicationEnd: "",
        datesLocked: 1,
        applicationEnabled: 1,
        waitlistEnabled: 1,
        groupRegistrationEnabled: 0,
        maxGroupPersons: 5,
        remarksEnabled: 1,
        public: 1,
        active: 1,
        customstyle: 0,
        colorPrimary: "",
        colorPrimaryGradient: "",
        colorSecondary: "",
        colorStdText: "",
        colorBtnText: "",
        colorTileBg: "",
        colorStdTextOnTile: ""
    });

    // const [formData, setFormData] = useState([])

    useEffect(() => {
        if (eventid != 0) {
            getEventData()

        } else {
            setLoadedEventData(1)
            setEventData({ ...eventData, orgid: param_orgid })
        }
        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])

    function getEventData() {
        setLoadedEventData(0)
        console.log("load start");

        try {

            fetch(URL_MAINAPI + "/event/" + eventid + "?ignoreinactive=1", {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {

                    setEventData(res.data)
                    console.log(res.data);


                    let dateStart_iso = new Date(res.data.dates?.dateStart || "1970-01-01T00:00:00.000Z")
                    let dateEnd_iso = new Date(res.data.dates?.dateEnd || "1970-01-01T00:00:00.000Z")
                    let applicationStart_iso = new Date(res.data.dates?.applicationStart || "1970-01-01T00:00:00.000Z")
                    let applicationEnd_iso = new Date(res.data.dates?.applicationEnd || "1970-01-01T00:00:00.000Z")

                    const offset = dateStart_iso.getTimezoneOffset();
                    let dateStart_local = new Date(dateStart_iso.getTime() - (offset * 60 * 1000))
                    let dateEnd_local = new Date(dateEnd_iso.getTime() - (offset * 60 * 1000))
                    let applicationStart_local = new Date(applicationStart_iso.getTime() - (offset * 60 * 1000))
                    let applicationEnd_local = new Date(applicationEnd_iso.getTime() - (offset * 60 * 1000))

                    let dateStart_datetime = dateStart_local.toISOString().slice(0, 16);
                    let dateEnd_datetime = dateEnd_local.toISOString().slice(0, 16);
                    let applicationStart_datetime = applicationStart_local.toISOString().slice(0, 16);
                    let applicationEnd_datetime = applicationEnd_local.toISOString().slice(0, 16);
                    // var dateStart_datetime = dateStart_iso.toISOString().slice(0, 16);
                    //slice 0,10 für nur das Datum und 0,16 für datetime

                    setFormData({
                        name: res.data.name || "",
                        shortname: res.data.shortname || "",
                        longname: res.data.longname || "",
                        slogan: res.data.slogan || "Jetzt mithelfen!",
                        logo_img: res.data.logo_img || "/1Helferzeit-Logo2x.png",
                        hero_img: res.data.hero_img || "/eventpics/default/svteam_rounded.webp",
                        url: res.data.url || "",
                        box1Header: res.data.info?.box1Header || "",
                        box1Text: res.data.info?.box1Text || "",
                        box1HeroImg: res.data.info?.box1HeroImg || "",
                        box2Header: res.data.info?.box2Header || "",
                        box2Text1: res.data.info?.box2Text1 || "",
                        box2Text2: res.data.info?.box2Text2 || "",
                        box2CtaText: res.data.info?.box2CtaText || "Mitmachen",
                        box3Header: res.data.info?.box3Header || "",
                        box3Text: res.data.info?.box3Text || "",
                        box3Contents: res.data.info?.box3Contents || "",
                        box3LookingFor: res.data.info?.box3LookingFor || "",
                        box3CtaText: res.data.info?.box3CtaText || "Kontakt",
                        dateStart: dateStart_datetime,
                        dateEnd: dateEnd_datetime,
                        applicationStart: applicationStart_datetime,
                        applicationEnd: applicationEnd_datetime,
                        datesLocked: res.data.dates?.datesLocked,
                        applicationEnabled: res.data.dates?.applicationEnabled,
                        waitlistEnabled: res.data.waitlistEnabled,
                        groupRegistrationEnabled: res.data.groupRegistrationEnabled ?? 0,
                        maxGroupPersons: res.data.maxGroupPersons ?? 5,
                        remarksEnabled: res.data.remarksEnabled ?? 1,
                        public: res.data.public,
                        active: res.data.active,
                        customstyle: res.data.customstyle,
                        colorPrimary: res.data.style?.colorPrimary || "",
                        colorPrimaryGradient: res.data.style?.colorPrimaryGradient || "",
                        colorSecondary: res.data.style?.colorSecondary || "",
                        colorStdText: res.data.style?.colorStdText || "",
                        colorBtnText: res.data.style?.colorBtnText || "",
                        colorTileBg: res.data.style?.colorTileBg || "",
                        colorStdTextOnTile: res.data.style?.colorStdTextOnTile || ""
                    });

                    console.log(res.data.customstyle);


                    setLoadedEventData(1)
                    console.log("load finish");
                    console.log(eventData);
                    console.log(formData);


                } else {
                    setEventData([])
                    setLoadedEventData(0)

                }
            })
            )

        } catch (err) {
            setEventData([])
            setLoadedEventData(0)

        }

    }

    const [errors, setErrors] = useState({});

    function handleChange(e) {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        const fieldSchema = valschema_event[name];
        if (fieldSchema) {
            const { error } = fieldSchema.validate(value);
            // setErrors({ ...errors, [name]: error ? error.details[0].message : '' });
            setErrors({ ...errors, [name]: error ? 'Eingabe prüfen' : '' });
        }
    }


    function sendEventData() {

        document.querySelector("#responseInfo_loading").style.display = "block"
        document.querySelector("#responseInfo_wronginput").style.display = "none"
        document.querySelector("#responseInfo_done").style.display = "none"


        let dateStart_local = new Date(formData.dateStart)
        let dateEnd_local = new Date(formData.dateEnd)
        let applicationStart_local = new Date(formData.applicationStart)
        let applicationEnd_local = new Date(formData.applicationEnd)

        let dateStart_iso = dateStart_local.toISOString()
        let dateEnd_iso = dateEnd_local.toISOString()
        let applicationStart_iso = applicationStart_local.toISOString()
        let applicationEnd_iso = applicationEnd_local.toISOString()

        var reqbody = {
            orgid: eventData.orgid, //achtung andere quelle
            name: formData.name,
            shortname: formData.shortname,
            longname: formData.longname,
            slogan: formData.slogan,
            logo_img: formData.logo_img,
            hero_img: formData.hero_img,
            url: formData.url,
            info: {
                box1Header: formData.box1Header,
                box1Text: formData.box1Text,
                box1HeroImg: formData.box1HeroImg,
                box2Header: formData.box2Header,
                box2Text1: formData.box2Text1,
                box2Text2: formData.box2Text2,
                box2CtaText: formData.box2CtaText,
                box3Header: formData.box3Header,
                box3Text: formData.box3Text,
                box3Contents: formData.box3Contents,
                box3LookingFor: formData.box3LookingFor,
                box3CtaText: formData.box3CtaText,
            },
            dates: {
                dateStart: dateStart_iso,
                dateEnd: dateEnd_iso,
                applicationStart: applicationStart_iso,
                applicationEnd: applicationEnd_iso,
                datesLocked: Number(formData.datesLocked),
                applicationEnabled: Number(formData.applicationEnabled),
            },
            waitlistEnabled: Number(formData.waitlistEnabled),
            groupRegistrationEnabled: Number(formData.groupRegistrationEnabled),
            maxGroupPersons: Number(formData.maxGroupPersons),
            remarksEnabled: Number(formData.remarksEnabled),
            public: Number(formData.public),
            active: Number(formData.active),
            customstyle: Number(formData.customstyle),
            style: {
                colorPrimary: formData.colorPrimary || "#000000",
                colorPrimaryGradient: formData.colorPrimaryGradient || "#000000",
                colorSecondary: formData.colorSecondary || "#000000",
                colorStdText: formData.colorStdText || "#000000",
                colorBtnText: formData.colorBtnText || "#000000",
                colorTileBg: formData.colorTileBg || "#000000",
                colorStdTextOnTile: formData.colorStdTextOnTile || "#000000"
            }
        }
        console.log(reqbody);
        console.log(reqbody.customstyle);


        try {
            fetch(URL_MAINAPI + (eventid == 0 ? "/event/create" : "/event/" + eventid), {
                method: eventid == 0 ? "POST" : "PATCH",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken

                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_done").style.display = "block"

                    setResError("");

                    lP("/manage/event/edit/" + res.data.eventid)
                    //TODO Daten neuladen, bei create seite wechseln zu edit


                } else {
                    console.log(res.data)
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                }
            })
            )
        } catch (err) {
            console.log(err)
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }



    return (
        <div className='mainCon page' id='mainCon'>

            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                {eventid == 0 ? <title>Event erstellen</title> : <title>Event bearbeiten</title>}
                <meta property="og:title" content={eventid == 0 ? "Event erstellen" : "Event bearbeiten"} />
                <meta property="og:description" content="Verwalte deine Veranstaltung" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    {eventData.orgid ? (
                        <a href={'/manage/org/' + eventData.orgid}>Organisation</a>
                    ) : (
                        <a href='/profil'>Profil</a>
                    )}
                    <FontAwesomeIcon icon={faChevronRight} />
                    {eventid != 0 ? (
                        <>
                            <a href={'/manage/event/' + eventid}>Event</a>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </>
                    ) : null}
                    <span>{eventid == 0 ? 'Event erstellen' : 'Event bearbeiten'}</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    {eventid == 0 ? '🛠️ Event erstellen' : '🛠️ Event bearbeiten'}
                </motion.h1>

                {(!loadedEventData) ? (
                    <Skeleton variant="card" />
                ) : (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card manage-edit-card' style={{ padding: '28px 30px', marginTop: '20px' }}>
                            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
                                <a href={"/manage/org/" + eventData.orgid} className="btn btn-secondary btn-sm">← Zur Organisation</a>
                                {(eventid != 0) ? <a href={"/manage/event/" + eventid} className="btn btn-secondary btn-sm">Event verwalten</a> : null}
                                {(eventid != 0) ? <a target="_blank" href={"/event/" + eventid} className="btn btn-secondary btn-sm">Eventvorschau ↗</a> : null}
                            </div>

                            {(eventData.active != 1 && eventid != 0) ? (
                                <div className='banner-info' style={{ background: 'var(--warn-soft)', color: 'var(--warn)', marginBottom: '16px' }}>
                                    ⚠️ Event ist inaktiv und für andere nicht aufrufbar!
                                </div>
                            ) : null}

                            <form>
                                                    <h4>Allgemeine Daten</h4>
                                                    <hr></hr>
                                                    <div className='inputdiv_line'>
                                                        <div className="inputdiv tip-parent">
                                                            <b>Eventname</b>
                                                            <input type="text" className={"in_eventname" + (errors.name ? ' input-error' : '')} name="name" placeholder="Beispielevent 25" autoFocus value={formData.name} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                            {errors.name && <small className="error-text">{errors.name}</small>}

                                                        </div>
                                                        <div className="inputdiv inputdiv_short tip-parent">
                                                            <b>Eventname (kurz)</b>
                                                            <input type="text" className={"in_eventshortname" + (errors.shortname ? ' input-error' : '')} name="shortname" placeholder="bsp25" value={formData.shortname} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                            {errors.shortname && <small className="error-text">{errors.shortname}</small>}

                                                        </div>
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Eventname (lang)</b>
                                                        <input type="text" className={"in_eventlongname" + (errors.longname ? ' input-error' : '')} name="longname" placeholder="Veranstaltung als Beispiel 2025" value={formData.longname} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.longname && <small className="error-text">{errors.longname}</small>}

                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Slogan</b>
                                                        <input type="text" className={"in_eventslogan" + (errors.slogan ? ' input-error' : '')} name="slogan" placeholder="Jetzt mithelfen" value={formData.slogan} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.slogan && <small className="error-text">{errors.slogan}</small>}

                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Logo-Bild URL</b>
                                                        <input type="url" className={"in_eventlogoimg" + (errors.logo_img ? ' input-error' : '')} name="logo_img" placeholder="-nicht verfügbar-" value={formData.logo_img} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        <div className="tool-tip">Zum Ändern an info@helferzeit.de wenden</div>
                                                        {errors.logo_img && <small className="error-text">{errors.logo_img}</small>}

                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Hero-Bild URL</b>
                                                        <input type="url" className={"in_eventheroimg" + (errors.hero_img ? ' input-error' : '')} name="hero_img" placeholder="-nicht verfügbar-" value={formData.hero_img} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        <div className="tool-tip">Zum Ändern an info@helferzeit.de wenden</div>
                                                        {errors.hero_img && <small className="error-text">{errors.hero_img}</small>}

                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Link zur Eventseite</b>
                                                        <input type="url" className={"in_eventurl" + (errors.url ? ' input-error' : '')} name="url" placeholder="https://beispiel.de" value={formData.url} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        <div className="tool-tip">Füge hier die URL zu deiner eigenen Event-Webseite ein</div>
                                                        {errors.url && <small className="error-text">{errors.url}</small>}
                                                    </div>

                                                    <br />
                                                    <h4>Eventbeschreibung</h4>
                                                    <hr></hr>
                                                    <div className="inputdiv tip-parent">
                                                        <b>Abschnitt 1: Überschrift</b>
                                                        <input type="text" className={"in_eventbox1header" + (errors.box1Header ? ' input-error' : '')} name="box1Header" placeholder="Über das Beispiel" value={formData.box1Header} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box1Header && <small className="error-text">{errors.box1Header}</small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 1: Text</b>
                                                        <textarea className={"in_eventbox1text" + (errors.box1Text ? ' input-error' : '')} name="box1Text" placeholder="Das ist ein Beispielevent" value={formData.box1Text} autoComplete='off' onInput={(e) => handleChange(e)}></textarea>
                                                        {errors.box1Text && <small className="error-text">{errors.box1Text}</small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 1: Hero-Bild URL (optional)</b>
                                                        <input type="url" className={"in_eventbox1heroimg" + (errors.box1HeroImg ? ' input-error' : '')} name="box1HeroImg" placeholder="https://beispiel.de/bild.png" value={formData.box1HeroImg} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box1HeroImg && <small className="error-text">{errors.box1HeroImg}</small>}
                                                    </div>
                                                    <div className="inputdiv tip-parent">
                                                        <b>Abschnitt 2: Überschrift</b>
                                                        <input type="text" className={"in_eventbox2header" + (errors.box2Header ? ' input-error' : '')} name="box2Header" placeholder="Aufgaben beim Beispielevent" value={formData.box2Header} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box2Header && <small className="error-text">{errors.box2Header}</small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 2: Text 1</b>
                                                        <textarea className={"in_eventbox2text1" + (errors.box2Text1 ? ' input-error' : '')} name="box2Text1" placeholder="Das erwartet dich beim Beispielevent" value={formData.box2Text1} autoComplete='off' onInput={(e) => handleChange(e)}></textarea>
                                                        {errors.box2Text1 && <small className="error-text">{errors.box2Text1} </small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 2: Text 2</b>
                                                        <textarea className={"in_eventbox2text2" + (errors.box2Text2 ? ' input-error' : '')} name="box2Text2" placeholder="Das solltest du mitbringen" value={formData.box2Text2} autoComplete='off' onInput={(e) => handleChange(e)}></textarea>
                                                        {errors.box2Text2 && <small className="error-text">{errors.box2Text2} </small>}
                                                    </div>
                                                    <div className="inputdiv tip-parent">
                                                        <b>Abschnitt 2: Button Text</b>
                                                        <input type="text" className={"in_eventbox2ctatext" + (errors.box2CtaText ? ' input-error' : '')} name="box2CtaText" placeholder="Mitmachen" value={formData.box2CtaText} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box2CtaText && <small className="error-text">{errors.box2CtaText} </small>}
                                                    </div>
                                                    <div className="inputdiv tip-parent">
                                                        <b>Abschnitt 3: Überschrift</b>
                                                        <input type="text" className={"in_eventbox3header" + (errors.box3Header ? ' input-error' : '')} name="box3Header" placeholder="Eckdaten des Events" value={formData.box3Header} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box3Header && <small className="error-text">{errors.box3Header} </small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 3: Text</b>
                                                        <textarea className={"in_eventbox3text" + (errors.box3Text ? ' input-error' : '')} name="box3Text" placeholder="Hast du Fragen zum Beispielevent" value={formData.box3Text} autoComplete='off' onInput={(e) => handleChange(e)}></textarea>
                                                        {errors.box3Text && <small className="error-text">{errors.box3Text} </small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 3: Veranstaltungsinhalte</b>
                                                        <input type="text" className={"in_eventbox3contents" + (errors.box3Contents ? ' input-error' : '')} name="box3Contents" placeholder="Vorbereiten von Beispiel" value={formData.box3Contents} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box3Contents && <small className="error-text">{errors.box3Contents} </small>}
                                                    </div>
                                                    <div className="inputdiv inputdiv_dyn tip-parent">
                                                        <b>Abschnitt 3: Benötigte Helfer</b>
                                                        <input type="text" className={"in_eventbox3lookingfor" + (errors.box3LookingFor ? ' input-error' : '')} name="box3LookingFor" placeholder="Fahrer, Einlass, ..." value={formData.box3LookingFor} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box3LookingFor && <small className="error-text">{errors.box3LookingFor} </small>}
                                                    </div>
                                                    <div className="inputdiv tip-parent">
                                                        <b>Abschnitt 3: Button Text</b>
                                                        <input type="text" className={"in_eventbox3ctatext" + (errors.box3CtaText ? ' input-error' : '')} name="box3CtaText" placeholder="Kontakt" value={formData.box3CtaText} autoComplete='off' onInput={(e) => handleChange(e)}></input>
                                                        {errors.box3CtaText && <small className="error-text">{errors.box3CtaText} </small>}
                                                    </div>
                                                    <br />
                                                    <h4>Meta-Daten</h4>
                                                    <hr></hr>


                                                    <div className="inputdiv tip-parent">
                                                        <b>Startdatum</b>
                                                        <input type="datetime-local" className={"in_eventdatestart" + (errors.dateStart ? ' input-error' : '')} name="dateStart" value={formData.dateStart} onInput={(e) => handleChange(e)} />
                                                        {errors.dateStart && <small className="error-text">{errors.dateStart} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Enddatum</b>
                                                        <input type="datetime-local" className={" in_eventdateend" + (errors.dateStart ? ' input-error' : '')} name="dateEnd" value={formData.dateEnd} onInput={(e) => handleChange(e)} />
                                                        {errors.dateEnd && <small className="error-text">{errors.dateEnd} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Bewerbungsbeginn</b>
                                                        <input type="datetime-local" className={"in_eventapplicationstart" + (errors.applicationStart ? ' input-error' : '')} name="applicationStart" value={formData.applicationStart} onInput={(e) => handleChange(e)} />
                                                        {errors.applicationStart && <small className="error-text">{errors.applicationStart} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Bewerbungsende</b>
                                                        <input type="datetime-local" className={"in_eventapplicationend" + (errors.applicationEnd ? ' input-error' : '')} name="applicationEnd" value={formData.applicationEnd} onInput={(e) => handleChange(e)} /></div>
                                                    {errors.applicationEnd && <small className="error-text">{errors.applicationEnd} </small>}
                                                    <div className="inputdiv tip-parent">
                                                        <b>Zeitplan-Bearbeitung</b>

                                                        <select disabled className={"in_eventdateslocked" + (errors.datesLocked ? ' input-error' : '')} name="datesLocked" value={Number(formData.datesLocked)} placeholder="Zeitplan-Bearbeitung" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>✅ möglich</option>
                                                                <option value={1}>🔒 gesperrt</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Zum Ändern an info@helferzeit.de wenden</div>
                                                        {errors.datesLocked && <small className="error-text">{errors.datesLocked} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Bewerbungsphase</b>
                                                        <select className={"in_eventapplicationenabled" + (errors.applicationEnabled ? ' input-error' : '')} name="applicationEnabled" value={Number(formData.applicationEnabled)} placeholder="Bewerbungsphase" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>🛑 Inaktiv</option>
                                                                <option value={1}>✅ Aktiv</option>
                                                            </optgroup>
                                                        </select>
                                                        {errors.applicationEnabled && <small className="error-text">{errors.applicationEnabled} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Warteliste nutzen</b>
                                                        <select className={"in_eventwaitlistenabled" + (errors.waitlistEnabled ? ' input-error' : '')} name="waitlistEnabled" value={Number(formData.waitlistEnabled)} placeholder="Warteliste" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>⛔️ Keine Warteliste</option>
                                                                <option value={1}>📝 Warteliste aktiv</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Wenn alle Plätze für einen Dienst belegt sind, können sich Helfer für die Warteliste eintragen</div>
                                                        {errors.waitlistEnabled && <small className="error-text">{errors.waitlistEnabled} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Gruppenanmeldung</b>
                                                        <select className={"in_eventgroupregistrationenabled" + (errors.groupRegistrationEnabled ? ' input-error' : '')} name="groupRegistrationEnabled" value={Number(formData.groupRegistrationEnabled)} placeholder="Gruppenanmeldung" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>⛔️ Deaktiviert</option>
                                                                <option value={1}>👥 Aktiv</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Helfer können weitere Personen ohne eigenen Account mitbringen. Nachträgliches Deaktivieren ist riskant: Bestehende Gruppenanmeldungen bleiben erhalten und zählen weiter zur Kapazität.</div>
                                                        {errors.groupRegistrationEnabled && <small className="error-text">{errors.groupRegistrationEnabled} </small>}
                                                    </div>

                                                    {Number(formData.groupRegistrationEnabled) === 1 ? (
                                                        <div className="inputdiv tip-parent">
                                                            <b>Max. zusätzliche Personen</b>
                                                            <input
                                                                type="number"
                                                                min={1}
                                                                max={30}
                                                                className={"in_eventmaxgrouppersons" + (errors.maxGroupPersons ? ' input-error' : '')}
                                                                name="maxGroupPersons"
                                                                value={formData.maxGroupPersons}
                                                                required
                                                                onInput={(e) => handleChange(e)}
                                                            />
                                                            <div className="tool-tip">Erlaubt 1–30 Mitbringer zusätzlich zum anmeldenden Helfer. Eine nachträgliche Verringerung gilt nur für neue Anmeldungen; bereits gemeldete größere Gruppen bleiben bestehen.</div>
                                                            {errors.maxGroupPersons && <small className="error-text">{errors.maxGroupPersons} </small>}
                                                        </div>
                                                    ) : null}

                                                    <div className="inputdiv tip-parent">
                                                        <b>Bemerkungsfeld</b>
                                                        <select className={"in_eventremarksenabled" + (errors.remarksEnabled ? ' input-error' : '')} name="remarksEnabled" value={Number(formData.remarksEnabled)} placeholder="Bemerkungsfeld" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>⛔️ Deaktiviert</option>
                                                                <option value={1}>💬 Aktiv</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Helfer können bei der Dienstanmeldung eine optionale Bemerkung hinterlassen. Nachträgliches Deaktivieren verhindert nur neue Bemerkungen; bereits gespeicherte bleiben erhalten.</div>
                                                        {errors.remarksEnabled && <small className="error-text">{errors.remarksEnabled} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Sichtbarkeit</b>
                                                        <select className={"in_eventpublic" + (errors.public ? ' input-error' : '')} name="public" value={Number(formData.public)} placeholder="Sichtbarkeit" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={1}>🌐 Öffentlich</option>
                                                                <option value={0}>🔗 Per Link</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Nur per Link erreichbar oder öffentlich in der Liste anzeigen</div>
                                                        {errors.public && <small className="error-text">{errors.public} </small>}
                                                    </div>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Status</b>
                                                        <select className={"in_eventactive" + (errors.active ? ' input-error' : '')} name="active" value={Number(formData.active)} placeholder="Status" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>🛑 Inaktiv</option>
                                                                <option value={1}>✅ Aktiv</option>
                                                            </optgroup>
                                                        </select>
                                                        {/* <div className="tool-tip">Zum Ändern an info@helferzeit.de wenden</div> */}
                                                        {errors.active && <small className="error-text">{errors.active} </small>}
                                                    </div>

                                                    <br />
                                                    <h4>Benutzerdefiniertes Design</h4>
                                                    <p>
                                                        Optional, nur für erfahrene Nutzer! Die Farbcodes müssen als Hex-Code angegeben werden. Die Kontraste bzw. Lesbarkeit sollte ausführlich getestet werden.
                                                    </p>
                                                    <hr></hr>

                                                    <div className="inputdiv tip-parent">
                                                        <b>Design auswählen</b>

                                                        <select className={"in_eventcustomstyle" + (errors.customstyle ? ' input-error' : '')} name="customstyle" value={Number(formData.customstyle)} placeholder="Custom-Style" required onChange={(e) => handleChange(e)}>
                                                            <optgroup label="">
                                                                <option value={0}>Standard-Design</option>
                                                                <option value={1}>Benutzerdefiniert ⚠️</option>
                                                            </optgroup>
                                                        </select>
                                                        <div className="tool-tip">Bei Fragen an info@helferzeit.de wenden</div>
                                                        {errors.customstyle && <small className="error-text">{errors.customstyle} </small>}
                                                    </div>
                                                    {formData.customstyle == 1 ? <div>
                                                        <div className="inputdiv tip-parent">
                                                            <b>Primär-Farbe</b>
                                                            <input type="text" className={"in_eventcolorprimary" + (errors.colorPrimary ? ' input-error' : '')} name="colorPrimary" placeholder="#ffffff" value={formData.colorPrimary} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorPrimary && <small className="error-text">{errors.colorPrimary} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Primär-Farbverlauf</b>
                                                            <input type="text" className={"in_eventcolorprimarygradient" + (errors.colorPrimaryGradient ? ' input-error' : '')} name="colorPrimaryGradient" placeholder="#acacacff" value={formData.colorPrimaryGradient} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorPrimaryGradient && <small className="error-text">{errors.colorPrimaryGradient} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Sekundär-Farbe</b>
                                                            <input type="text" className={"in_eventcolorsecondary" + (errors.colorSecondary ? ' input-error' : '')} name="colorSecondary" placeholder="#000000" value={formData.colorSecondary} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorSecondary && <small className="error-text">{errors.colorSecondary} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Standard-Textfarbe</b>
                                                            <input type="text" className={"in_eventcolorstdtext" + (errors.colorStdText ? ' input-error' : '')} name="colorStdText" placeholder="#000000" value={formData.colorStdText} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorStdText && <small className="error-text">{errors.colorStdText} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Button-Textfarbe</b>
                                                            <input type="text" className={"in_eventcolorbtntext" + (errors.colorBtnText ? ' input-error' : '')} name="colorBtnText" placeholder="#ffffff" value={formData.colorBtnText} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorBtnText && <small className="error-text">{errors.colorBtnText} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Kachel-Hintergrundfarbe</b>
                                                            <input type="text" className={"in_eventcolortilebg" + (errors.colorTileBg ? ' input-error' : '')} name="colorTileBg" placeholder="#f5f5f5" value={formData.colorTileBg} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorTileBg && <small className="error-text">{errors.colorTileBg} </small>}
                                                        </div>

                                                        <div className="inputdiv tip-parent">
                                                            <b>Textfarbe auf Kacheln</b>
                                                            <input type="text" className={"in_eventcolorstdtextontile" + (errors.colorStdTextOnTile ? ' input-error' : '')} name="colorStdTextOnTile" placeholder="#000000" value={formData.colorStdTextOnTile} autoComplete="off" onInput={(e) => handleChange(e)} />
                                                            {errors.colorStdTextOnTile && <small className="error-text">{errors.colorStdTextOnTile} </small>}
                                                        </div>
                                                    </div> : null}
                                                    <br /><br />
                                                    <p className="responseInfo" id="responseInfo_loading">
                                                        Lädt... Bitte warten...
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_wronginput">
                                                        Bitte überprüfe deine Eingaben!<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_servererror">
                                                        Es gab einen Fehler bei der Verarbeitung.<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_done">
                                                        Erfolgreich gespeichert
                                                    </p>
                                                    <br /><br />
                                                    <CTAButton variant="primary" block={true} id="save_btn" hideArrow={false} title={"Speichern"} onclick={() => sendEventData()}></CTAButton>

                                                </form>
                        </div>
                    </motion.div>
                )}

            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}